module.exports = __webpack_public_path__ + "static/media/salisbury-5.249652db.jpg";